import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

type ChartCardProps = {
  title: string;
  description: string;
  children: ReactNode;
  controls?: ReactNode;
  legend?: ReactNode;
  annotation?: ReactNode;
  contentClassName?: string;
};

export function ChartCard({ title, description, children, controls, legend, annotation, contentClassName }: ChartCardProps) {
  return (
    <Card className="brand-frame border-border/80 bg-card/92">
      <CardHeader className="gap-4 border-b border-border/70 pb-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div className="flex flex-1 flex-col gap-1.5">
            <CardTitle className="font-display text-[1.35rem] leading-tight text-foreground">{title}</CardTitle>
            <CardDescription className="max-w-2xl text-sm leading-6">{description}</CardDescription>
          </div>
          {controls ? <div className="flex shrink-0 items-center gap-2">{controls}</div> : null}
        </div>
        {annotation ? (
          <div className="rounded-xl border border-border/70 bg-secondary/25 px-4 py-3 text-sm text-muted-foreground">{annotation}</div>
        ) : null}
        {legend ? (
          <ScrollArea className="w-full whitespace-nowrap">
            <div className="flex w-max min-w-full items-center gap-2 pb-2">{legend}</div>
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        ) : null}
      </CardHeader>
      <CardContent className={contentClassName}>{children}</CardContent>
    </Card>
  );
}
